'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useHeaderState } from './HeaderStateContext';
import { headerCssClassNames } from './headerCssClassNames';
const logoCDN = 'https://cdn.ux.deere.com/brand-foundations/1.4.0/logos';
const getLogoInformation = (theme, variant = 'default', isMobile) => {
    const logoColor = theme.name === 'jdBlack' ? 'black' : 'green';
    const logoInformation = {
        bjd: {
            image: 'bjd-logo.svg',
            altText: 'Banco John Deere Logo'
        },
        jdf: {
            image: isMobile ? 'jdf-logo.svg' : 'jdf-inline-logo.svg',
            altText: 'John Deere Financial Logo'
        },
        default: {
            image: 'jd-logo.svg',
            altText: 'John Deere Logo'
        }
    }[variant];
    logoInformation.image = `${logoInformation.image}#${logoColor}`;
    return logoInformation;
};
export const HeaderLogo = React.forwardRef((_, ref) => {
    const theme = useTheme();
    const { variant, isMobile, isSmallMobile, HeaderLogoProps } = useHeaderState();
    const imageInfo = getLogoInformation(theme, variant, isMobile || isSmallMobile);
    const imageHeight = isSmallMobile ? '28px' : '32px';
    return (_jsx("img", { alt: imageInfo.altText, ref: ref, src: `${logoCDN}/${imageInfo.image}`, ...HeaderLogoProps, className: headerCssClassNames.logo, height: imageHeight, width: 'auto' }));
});
HeaderLogo.displayName = 'HeaderLogo';
